<template>
    <div class="weekly-event-line" @change="sendDataForSaving">
        <div class="weekly-event-line-content">
            <div class="day-name">
                {{ form.day }}
            </div>
            <div class="time-selection" v-if="form.isUnavailable">
                <p>
                    Unavailable
                </p>
            </div>
            <div class="time-selection" v-else>
                <div class="start">
                    <date-picker
                        v-model="form.start"
                        format="hh:mm a"
                        value-type="format"
                        type="time"
                        placeholder="HH:MM AM/PM"
                        @close="sendDataForSaving"
                    ></date-picker>
                </div>

                <div class="sep"></div>
                <div class="end">
                    <date-picker
                        v-model="form.end"
                        format="hh:mm a"
                        value-type="format"
                        type="time"
                        placeholder="HH:MM AM/PM"
                        @close="sendDataForSaving"
                    ></date-picker>
                </div>
            </div>

        </div>
        <div class="action-block">
            <button
                v-if="form.isUnavailable === false"
                class="img-btn"
                @click="closeDay"
            ><img src="/img/svg/no.svg" alt="close"></button>
            <button
                v-if="form.isUnavailable === true"
                class="img-btn"
                @click="openDay"
            ><img src="/img/svg/add.svg" alt="add"></button>
            <button
                v-if="form.isUnavailable === false"
                class="img-btn"
                @click="saveDataToStorage"
            ><img src="/img/svg/duplicat.svg" alt="copy">
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name: "DayAvailability",
    props: {
        day: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            savedData: {},
            form: {
                index: this.day.index,
                day: this.day.day,
                isUnavailable: this.day.isUnavailable,
                start: this.day.start,
                end: this.day.end,
            }
        }
    },
    emits: ['data-changed'],
    methods: {
        openDay() {
            this.form.isUnavailable = false
            this.setDataFromStorage()
        },
        setDataFromStorage() {
            if (localStorage.getItem('savedData') !== null) {
                const savedData = localStorage.getItem('savedData');
                if (savedData) {
                    const parsedData = JSON.parse(savedData);
                    this.form.start = parsedData.start
                    this.form.end = parsedData.end
                    localStorage.clear();
                    this.sendDataForSaving()
                }
            }
        },
        saveDataToStorage() {
            const dataToSave = JSON.stringify({ start: this.form.start, end: this.form.end });
            localStorage.setItem('savedData', dataToSave);
        },
        closeDay() {
            this.form.isUnavailable = true
            this.form.start = null
            this.form.end = null
            this.sendDataForSaving()
        },
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },

    }

}
</script>

<style scoped>

</style>
